"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgFlightDirect = function SvgFlightDirect(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138 19",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#EBECF0",
    d: "M8 18.3S27.915 15 71.207 15c43.293 0 63.208 3.3 63.208 3.3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 18.5,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#179FE3",
    d: "M19.476 12.954C29.789 10.774 50.402 8 69.69 8c43.292 0 63.207 9.909 63.207 9.909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.682 8.174 125 7.216s-.794-.188-1.367-1.291a212.204 212.204 0 0 1-1.145-2.246s-.093-.27-.394-.263c-.301.006-.22.331-.22.331l.132 2.31s-.054.56.397.953c.452.393 1.815 1.52 1.815 1.52s.94.763 2.505 1.308c1.564.545 7.09 2.547 7.09 2.547s2.092.826 2.328.382c.236-.444-.57-1.244-1.042-1.556-.472-.313-4.968-2.095-4.968-2.095l-1.685-4.58s-.266-.553-.347-.103c-.081.45-.488 4.546-.488 4.546m-.559 1.926-.176 1.758s.006.463.828-.108c.822-.571 1.45-.984 1.45-.984M7.274 17.005l-2.432 1.482s-.646.5-1.864.25c-1.217-.25-2.466-.524-2.466-.524s-.268-.097-.452.141c-.185.238.119.38.119.38l1.878 1.35s.4.395.99.291c.59-.103 2.325-.453 2.325-.453s1.184-.251 2.592-1.124c1.408-.872 6.44-3.907 6.44-3.907s1.96-1.106 1.763-1.569c-.196-.463-1.325-.339-1.865-.17-.54.17-4.755 2.543-4.755 2.543l-4.619-1.573s-.597-.14-.298.206c.298.346 3.225 3.24 3.225 3.24M9 19.214l1.255 1.243s.364.287.438-.711c.073-.999.147-1.746.147-1.746",
    stroke: "#4D4D4D"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgFlightDirect);
var _default = Memo;
exports["default"] = _default;